import apiClient from '../api.js';
import { conToken } from '../autorizacion.js';

// Capa de servicios de los ítems de cada plan económico (HU-14).
// Backend: `UNICEN/modules/economico`. Contrato completo:
// UNICEN/modules/economico/docs/items-plan.openapi.yaml
//
// Token obligatorio, `{ data }`, errores `{ mensaje, campo?, rechazadas? }` (leer con `errorDeApi`).
//
//   GET    /economico/items-plan/:id_plan/matriz?buscar&con_excepciones&pagina&limite
//          -> { plan, grupos, items: [{ id_item, nombre, modo, item_activo, excepciones, celdas }], total, pagina, limite }
//   GET    /economico/items-plan/:id_plan/disponibles?buscar       -> { items }
//   POST   /economico/items-plan/:id_plan/items { items, modo: 'TODOS'|'ALGUNOS', grupos? }
//   PUT    /economico/items-plan/:id_plan/items/:id_item/grupos/:id_grupo { cobra } -> { cambio, item }
//   DELETE /economico/items-plan/:id_plan/items/:id_item
//   GET    /economico/items-plan/:id_plan/historial?pagina&limite
//   GET    /economico/items-plan/resolucion?id_plan&id_item&(id_grupo | id_sede&id_carrera&id_plan_estudio)

const resource = '/economico/items-plan';

const useItemsPlanApi = {
  /** { buscar, conExcepciones, pagina, limite } */
  matriz(idPlan, { buscar, conExcepciones, pagina, limite } = {}) {
    return apiClient.get(`${resource}/${idPlan}/matriz`, conToken({
      params: { buscar: buscar || undefined, con_excepciones: conExcepciones || undefined, pagina, limite },
    }));
  },

  disponibles(idPlan, buscar) {
    return apiClient.get(`${resource}/${idPlan}/disponibles`, conToken({ params: { buscar: buscar || undefined } }));
  },

  agregar(idPlan, { items, modo, grupos }) {
    return apiClient.post(`${resource}/${idPlan}/items`, { items, modo, grupos: modo === 'ALGUNOS' ? grupos : undefined }, conToken());
  },

  cambiarCelda(idPlan, idItem, idGrupo, cobra) {
    return apiClient.put(`${resource}/${idPlan}/items/${idItem}/grupos/${idGrupo}`, { cobra }, conToken());
  },

  quitar(idPlan, idItem) {
    return apiClient.delete(`${resource}/${idPlan}/items/${idItem}`, conToken());
  },

  historial(idPlan, { pagina, limite } = {}) {
    return apiClient.get(`${resource}/${idPlan}/historial`, conToken({ params: { pagina, limite } }));
  },
};

export default useItemsPlanApi;
